import { useState } from 'react'
import useActivityFilterStore from '@app.feature/activityFilter/store/storeActivityFilter'
import useJobCategoryStore from '@app.feature/jobCategory/store/store.jobCategory'

export const useJobCategoryField = () => {
  const [bottomSheetOpen, setBottomSheetOpen] = useState<boolean>(false)
  const getCategoriesByIds = useJobCategoryStore(
    (state) => state.getCategoriesByIds,
  )
  const getChainingLabelById = useJobCategoryStore(
    (state) => state.getChainingLabelById,
  )
  const selectedFilter = useActivityFilterStore((state) => state.selectedFilter)
  const updateSelectedFilter = useActivityFilterStore(
    (state) => state.updateSelectedFilter,
  )

  const selectedCategoryIds = selectedFilter.categoryIDs

  const handleButtonClick = () => {
    setBottomSheetOpen(true)
  }

  const handleSubmit = (categoryIds: string[]) => {
    const categories = getCategoriesByIds(categoryIds).map((category) => ({
      id: category.id,
      label: getChainingLabelById(category.id),
    }))
    updateSelectedFilter({
      name: 'categoryIDs',
      filters: categories,
    })

    setBottomSheetOpen(false)
  }

  const handleClose = () => {
    setBottomSheetOpen(false)
  }

  return {
    sheetOpen: bottomSheetOpen,
    selectedCategoryIds,
    onButtonClick: handleButtonClick,
    onSheetClose: handleClose,
    onSheetSubmit: handleSubmit,
  }
}
